var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFalklandIslands(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0117C32 24.8482 24.8365 32.0117 16 32.0117C7.1635 32.0117 0 24.8482 0 16.0117C0 16.0155 16 0.0134688 16 0.0117188C24.8365 0.0117188 32 7.17522 32 16.0117Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9568 16.0118H15.9996C15.9996 15.9974 15.9996 15.9834 15.9996 15.969C15.9853 15.9833 15.9711 15.9975 15.9568 16.0118Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.35953C16 5.54422 16 3.69953 16 0.0117188H15.9973C7.162 0.0132188 0 7.17603 0 16.0117H8.34781V11.311L13.0486 16.0117H15.9572L16.0001 15.9689C16.0001 14.891 16.0001 13.9292 16.0001 13.0603L11.2992 8.35953H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09515 2.09854C5.59271 3.52348 3.51234 5.60385 2.0874 8.10629V16.0116H6.26134V6.2726V6.27248H16.0005C16.0005 4.95604 16.0005 3.70192 16.0005 2.09854H8.09515Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0008 14.0442L10.3162 8.35965H8.34863V8.35977L16.0006 16.0118H16.0008C16.0008 16.0118 16.0008 14.6551 16.0008 14.0442Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7396 18.7944V19.49H20.1744V18.7944H18.0874V21.5769H19.4787V22.2726H26.4353V21.5769H27.8265V18.7944H25.7396Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0874 8.35959V16.0118C18.0874 19.7392 22.957 20.8813 22.957 20.8813C22.957 20.8813 27.8265 19.7392 27.8265 16.0118V8.35959H18.0874Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9567 14.0676C21.7393 14.0676 21.7393 15.1807 20.522 15.1807C19.3047 15.1807 19.3047 14.0676 18.0874 14.0676V16.0154C19.3047 16.0154 19.3047 17.1285 20.522 17.1285C21.7393 17.1285 21.7393 16.0154 22.9567 16.0154C24.1741 16.0154 24.1741 17.1285 25.3916 17.1285C26.6091 17.1285 26.609 16.0154 27.8265 16.0154V14.0676C26.6091 14.0676 26.6091 15.1807 25.3916 15.1807C24.1741 15.1807 24.1741 14.0676 22.9567 14.0676V14.0676Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9567 10.1683C21.7393 10.1683 21.7393 11.2814 20.522 11.2814C19.3047 11.2814 19.3047 10.1683 18.0874 10.1683V12.1161C19.3047 12.1161 19.3047 13.2292 20.522 13.2292C21.7393 13.2292 21.7393 12.1161 22.9567 12.1161C24.1741 12.1161 24.1741 13.2292 25.3916 13.2292C26.6091 13.2292 26.609 12.1161 27.8265 12.1161V10.1683C26.6091 10.1683 26.6091 11.2814 25.3916 11.2814C24.1741 11.2814 24.1741 10.1683 22.9567 10.1683Z",
    fill: "#F3F3F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalklandIslands);
export default __webpack_public_path__ + "static/media/falkland-islands.e923e3e9.svg";
export { ForwardRef as ReactComponent };